import * as React from 'react';
import { useState } from 'react';
import GiftForm from "../../components/Gifts/GiftForm/GiftForm";
import Submenu from '../../components/Submenu/Submenu';
import AppMenus from '../../config/appMenus';
import AppRoutes from '../../config/appRoutes';
var Gift = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editSample.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u043F\u043E\u0434\u0430\u0440\u044A\u043A"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(GiftForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Gift;



//////////////////
// WEBPACK FOOTER
// ./src/views/Gifts/Gift.tsx
// module id = 357
// module chunks = 0